import { DestroyRef, inject, Injectable, Signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { patchState, SignalState, signalState } from '@ngrx/signals';
import { DefaultStoreStoreData } from './interfaces';
import { StoresService } from 'angular-api-gateway/v1/api/stores.service';
import { defaultApiGatewayParams } from '@lentau/core/api/gateway';

const defaultState: DefaultStoreStoreData = {
  loading: false,
  waitingForCheck: true,
};

// Этот стор не содержит значимых данных на фронте, однако триггер его метода
// устанавливает нужный дефолтный стор на бекенде, который будет возвращён соответствующим методом
@Injectable({ providedIn: 'root' })
export class DefaultStoreStore {
  private store: SignalState<DefaultStoreStoreData> = signalState(defaultState);

  private destroyRef: DestroyRef = inject(DestroyRef);
  private storesService: StoresService = inject(StoresService);

  public waitingForCheck: Signal<boolean> = this.store.waitingForCheck;
  public loading: Signal<boolean> = this.store.loading;

  public defaultStore(regionSlug: string, utmCampaign?: string, utmUserMode?: string): void {
    patchState(this.store, { loading: true, waitingForCheck: false });
    this.storesService
      .defaultStore({
        ...defaultApiGatewayParams,
        utmCampaign,
        utmUserMode,
        defaultStoreRequest: { regionSlug },
      })
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: () => patchState(this.store, { loading: false }),
        error: () => patchState(this.store, { loading: false }),
      });
  }

  public checkNotNeeded(): void {
    patchState(this.store, { waitingForCheck: false });
  }
}
